import { Link, useSearchParams } from "react-router-dom";
import { MailCheck, RefreshCw } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { authApi, ApiError } from "@/lib/api";

export default function VerifyPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const [sending, setSending] = useState(false);

  return (
    <div className="text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-info/10 text-info">
        <MailCheck className="h-7 w-7" />
      </div>
      <h1 className="mt-6 text-2xl font-bold tracking-tight">Confirm your email</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        We sent a confirmation link to{" "}
        <span className="font-medium text-foreground">{email || "your inbox"}</span>. Click the link
        to activate your operator account.
      </p>

      <div className="mt-6 rounded-lg border bg-surface-muted p-4 text-left text-sm">
        <div className="font-medium text-foreground">Didn't get it?</div>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-muted-foreground">
          <li>Check your spam / promotions folder.</li>
          <li>Confirm the address is spelled correctly.</li>
          <li>Give it up to 60 seconds to arrive.</li>
        </ul>
      </div>

      <div className="mt-6 flex flex-col gap-2">
        <Button
          variant="outline"
          onClick={async () => {
            if (!email) {
              toast.error("Missing email address");
              return;
            }
            setSending(true);
            try {
              await authApi.resendConfirmation(email);
              toast.success("Confirmation email resent");
            } catch (err) {
              toast.error(err instanceof ApiError ? err.message : "Could not resend email");
            } finally {
              setSending(false);
            }
          }}
          disabled={sending}
        >
          <RefreshCw className={sending ? "animate-spin" : ""} />
          {sending ? "Sending…" : "Resend email"}
        </Button>
        <Button asChild variant="ghost">
          <Link to="/auth/login">Back to sign in</Link>
        </Button>
      </div>
    </div>
  );
}
